var exports = {
  "mB": "xe30f6088--bb0a23--cg-row",
  "q1": "xe30f6088--bb0a23--cg-container-fluid-xs",
  "NG": "xe30f6088--bb0a23--cg-col-24",
};

module.exports = exports;
